const getYearMonthDayDate = (date) => {
  const offset = date.getTimezoneOffset()
  const yourDate = new Date(date.getTime() - offset * 60 * 1000)
  return yourDate.toISOString().split('T')[0]
}

export default getYearMonthDayDate
